/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import PageTabs from '@/components/shared/PageTabs';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute('/(client)/transactions/(pages)/(list)')({
  component: TransactionsLayout,
});

function TransactionsLayout() {
  const { getTranslation: t } = useTranslator({ page: 'fiberTransactions' });

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <PageTabs
        tabs={[
          {
            key: 'incoming',
            label: t('tab.incoming'),
            to: '/transactions/incoming',
          },
          {
            key: 'outgoing',
            label: t('tab.outgoing'),
            to: '/transactions/outgoing',
          },
        ]}
        mode='path'
        moreLabel={t('tab.more')}
      />
      <PageContainer>
        <Outlet />
      </PageContainer>
    </div>
  );
}
